import React from 'react'
import FormComponent from "../components/formComponent";
import { renderReport } from "../components/elementList";

let documentation = {
    title: 'Choose Dashboard',
    brief: 'Choose a Dashboard from the Thingsboard\'s ones.',
    content: 'Chooses a Dashboard and assigns it to a previously selected Acuadori customer (for each customer type).'
}

class UiGetDashboard extends React.Component {

    static defaultProps = {
        services: {
            dashboard: {}
        },
        defaultDashboard: 'the dashboard id'
    };

    constructor(props) {
        super(props);

        this.dashboardService = props.services.dashboard;

        this.state = {
            finished: false,
            dashboardList: null,
        }
    }

    componentDidMount() {
        this.dashboardService.getDashboards().then(this.handleGetDashboardsNext).catch(this.handleSubmitError);
    }

    handleGetDashboardsNext = (response) => {
        this.setState({ dashboardList: response.data });
    };

    handleSelectDashboardsNext = (dashboard) => {
        let dashboardObj = JSON.parse(dashboard.DASHBOARD);
        // this.setState({ dashboard: dashboardObj });

        let { customers } = this.props;
        let customerSelectedIds = customers.instances.map((instance) => {
            return instance.id;
        });
        let dashboardCustomerIds = (dashboardObj.assignedCustomers || []).map((instance) => {
            return instance.customerId.id;
        });

        let customerIds = [...customerSelectedIds, ...dashboardCustomerIds];
        customerIds = [...new Set(customerIds)];

        return this.assignDashboardToCustomers(dashboardObj, customerIds);
    };

    assignDashboardToCustomers = (dashboard, customerIds) => {
        return this.dashboardService.assignDashboardToCustomer(dashboard.id.id, customerIds)
            .then((response) => {
                const assignedDashboard = response && response.id && response.id.id
                    ? response
                    : dashboard;

                return this.handleAssignDashboardToCustomersNext(assignedDashboard);
            })
            .catch(this.handleSubmitError);
    };

    handleAssignDashboardToCustomersNext = (response) => {
        this.setState({ finished: true, dashboard: response });
        this.props.finished({ dashboard: response });
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderAlert = (message, variant) => {
        this.setState({ messageAlert: message, variantAlert: variant, showAlert: true });
    };

    renderSelectDashboard = () => {
        let { dashboardList } = this.state;
        let { defaultDashboard } = this.props;

        let chosenDashboard;

        let formElements = !!dashboardList ? dashboardList.map(dashboard => {
            if (defaultDashboard) {
                if (defaultDashboard === dashboard.id.id) {
                    chosenDashboard = { value: JSON.stringify(dashboard), label: dashboard.name };
                }
            }
            return { value: JSON.stringify(dashboard), label: dashboard.name }
        }) : null;


        let formElement;
        if (chosenDashboard) {
            formElement = [{
                key: 'DASHBOARD', type: 'input', inputType: 'text', placeholder: 'Dashboard: ' + chosenDashboard.name,
                label: 'Dashboard', disabled: true
            }];
        } else {
            formElement = [{
                key: 'DASHBOARD', type: 'select', inputType: 'select', placeholder: 'Select a dashboard',
                value: null, label: 'Dashboard', options: formElements
            }];
        };

        return (
            <div>
                {!!dashboardList && <FormComponent
                    initialValues={{ DASHBOARD: chosenDashboard ? chosenDashboard.label : '' }}
                    validateFunc={() => { }}
                    submitFunc={(value) => chosenDashboard ?
                        this.handleSelectDashboardsNext({ DASHBOARD: chosenDashboard.value }) :
                        this.handleSelectDashboardsNext(value)
                    }
                    inputs={formElement}
                />}
            </div>
        );
    };


    reportAllComponentData = () => {
        let { dashboard } = this.state;
        if (!dashboard) {
            return null;
        }

        let data = {
            'Dashboard id': dashboard.id.id,
            'Dashboard name': dashboard.name || dashboard.title
        };
        (dashboard.assignedCustomers || []).forEach((customer, index) => {
            data[`Customer Name ${index}`] = customer.title;
            data[`Customer ID ${index}`] = customer.customerId.id;
        });

        return data;
    };

    render() {
        let { finished } = this.state;
        return (
            <div className="container-fluid">
                <div className="m-4 p-4">
                    {!finished && this.renderSelectDashboard()}
                    {!!finished && renderReport(this.reportAllComponentData())}
                </div>
            </div>);
    }
}


export default UiGetDashboard;
export {
    UiGetDashboard,
    documentation
}
